<template>
  <el-container>
    <el-main>
      <div class="jumbotron">
        <h1 class="display-4">{{ $t("notFound404.title") }}</h1>
        <p class="lead">
          {{
            $t("notFound404.text")
          }}
        </p>
        <hr class="my-4" />
        <router-link class="btn btn-primar btn-lgy" :to="{ path: '/' }">{{
          $t("notFound404.link")
        }}</router-link>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('notFound404.metaTitle')
    }
  }
}
</script>
